<div class="new-enquiry-page">
  <!-- Header -->
  <header class="page-header">
    <div class="header-toolbar">
      <button class="back-button" (click)="router.navigate(['/dashboard'])">
        <i class="fas fa-arrow-left"></i>
      </button>
      <h1 class="page-title">New Enquiry</h1>
      
      <div class="new-location-select" *ngIf="locations.length > 0">
        <label for="location-select" class="location-label"><i class="fas fa-map-marker-alt"></i> Location</label>
        <select 
          id="location-select"
          class="custom-select location-dropdown"
          [(ngModel)]="selectedLocation"
        >
          <option value="">Select Location</option>
          <option *ngFor="let location of locations" [value]="location.branchId">
            {{ location.branchName }}
          </option>
        </select>
      </div>
    </div>
  </header>

  <div class="page-content">
    <div class="auth">
      <form class="form" (ngSubmit)="onSubmit()">

        <!-- Registration Number Section -->
        <div class="card mb-4 shadow-sm" style="border-radius: 12px; border: 1px solid #e0e0e0;">
          <div class="card-body p-4">
            <h5 class="fw-bold mb-3"><i class="fas fa-car me-2 text-primary"></i>Vehicle Registration No</h5>
            <div class="form-group">
              <!-- <label class="form-label text-muted small fw-bold mb-2">REG NO</label> -->
              <input type="text" [(ngModel)]="regNo" name="regNo" placeholder="vehicle Reg No" class="form-control form-control-lg border shadow-sm rounded-3 py-2">
            </div>
          </div>
        </div>

        <!-- Image Upload Section -->
        <div class="card mb-4 shadow-sm" style="border-radius: 12px; border: 1px solid #e0e0e0;">
          <div class="card-body p-4">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h5 class="fw-bold mb-0"><i class="fas fa-images me-2 text-primary"></i>Images (Max {{ MAX_IMAGES }})</h5>
              <button type="button" class="btn btn-outline-primary btn-sm rounded-pill px-3" (click)="imageInput.click()" [disabled]="uploadedImages.length >= MAX_IMAGES">
                <i class="fas fa-plus me-2"></i> Add Photo
              </button>
              <input #imageInput type="file" accept="image/*" multiple hidden (change)="onImageSelected($event)">
            </div>
            
            <p class="text-muted small fst-italic mb-3" *ngIf="uploadedImages.length === 0">No images selected yet.</p>

            <div class="row g-2">
              <div class="col-4 position-relative" *ngFor="let image of uploadedImages; let i = index">
                <div class="ratio ratio-1x1 border rounded-3 overflow-hidden shadow-sm" style="background-color: #f8f9fa;">
                  <img [src]="image.img_url || image.url || image" class="object-fit-cover w-100 h-100" style="cursor: pointer;" alt="Selected Image" (click)="openImagePreview(image.img_url || image.url || image)">
                </div>
                <button type="button" class="btn btn-danger btn-sm position-absolute top-0 end-0 m-1 rounded-circle p-0" style="width: 24px; height: 24px; line-height: 1;" (click)="removeImage(i)">
                  <i class="fas fa-times fs-6"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Compact Voice Input Card -->
        <div class="voice-card-compact mb-4 shadow-sm" style="border-radius: 12px;">
          <div class="voice-example-banner p-3 rounded-top" style="background-color: #e8f5f2; border: 1px solid #d1f0e8; border-bottom: none;">
            <div class="d-flex align-items-center mb-3">
              <div class="icon-circle bg-white shadow-sm d-flex justify-content-center align-items-center rounded-circle me-3" style="width: 40px; height: 40px;">
                <i class="fas fa-lightbulb text-warning"></i>
              </div>
              <div>
                <h5 class="mb-0 fw-bold">Sample Voice Input</h5>
                <small class="text-muted">Listen to get it right!</small>
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-between bg-white p-3 rounded-3 shadow-sm border flex-wrap gap-2">
              <div class="d-flex align-items-center">
                <i class="fas fa-comment-dots text-success me-3 fs-4"></i>
                <p class="mb-0 fst-italic" style="font-size: 0.9rem;">"Maruti Swift Diesel Manual 2022 VDI, I need Front brake pads and clutch plate"</p>
              </div>
              <button type="button" class="btn btn-sm btn-success rounded-pill px-3 d-flex align-items-center flex-shrink-0" (click)="playExampleVoice($event)">
                <i class="fas me-2" [ngClass]="isPlayingExample ? 'fa-pause-circle' : 'fa-play-circle'"></i>
                <span>{{ isPlayingExample ? 'Playing...' : 'Play Example' }}</span>
              </button>
            </div>
          </div>

          <div class="voice-compact-body p-4 rounded-bottom shadow-sm border text-center" style="background-color: #ffffff; border-color: #d1f0e8;">
            <input #existingAudioInput type="file" accept="audio/*" hidden (change)="onExistingAudioSelected($event)">
            
            <!-- No Recording Yet -->
            <div class="d-flex justify-content-center gap-3" *ngIf="!recordedAudioBlob && !isRecording">
              <button type="button" class="btn btn-success d-flex flex-column align-items-center justify-content-center py-3 px-4 rounded-4 shadow-sm border-0" style="background: linear-gradient(135deg, #28a745 0%, #20c997 100%);" (click)="startVehicleRecording()">
                <i class="fas fa-microphone fs-2 mb-2 text-white"></i>
                <span class="fw-bold text-white">Start Recording</span>
              </button>
              <button type="button" class="btn btn-outline-secondary d-flex flex-column align-items-center justify-content-center py-3 px-4 rounded-4 shadow-sm bg-light border-0" (click)="existingAudioInput.click()">
                <i class="fas fa-folder-open fs-2 mb-2 text-secondary"></i>
                <span class="fw-bold text-secondary">Choose Audio File</span>
              </button>
            </div>

            <!-- Currently Recording -->
            <div class="d-flex flex-column align-items-center justify-content-center" *ngIf="isRecording">
              <div class="d-flex align-items-center mb-3">
                <i class="fas fa-circle text-danger me-2" style="animation: pulse 1.5s infinite;"></i>
                <span class="fw-bold text-danger fs-5">Recording...</span>
              </div>
              <button type="button" class="btn btn-danger rounded-circle shadow d-flex justify-content-center align-items-center" style="width: 80px; height: 80px;" (click)="stopVehicleRecording()">
                <i class="fas fa-stop fs-2"></i>
              </button>
            </div>

            <!-- Recording Complete but NOT Confirmed -->
            <div class="d-flex justify-content-center gap-4" *ngIf="recordedAudioBlob && !isRecording && !isAudioConfirmed">
              <button type="button" class="btn btn-outline-success rounded-circle shadow-sm d-flex justify-content-center align-items-center" style="width: 60px; height: 60px;" (click)="playRecordedAudio()" [disabled]="isUploadingVoice">
                <i class="fas fs-3" [ngClass]="isPlayingRecording ? 'fa-pause' : 'fa-play'"></i>
              </button>
              <button type="button" class="btn btn-success rounded-circle shadow-sm d-flex justify-content-center align-items-center" style="width: 60px; height: 60px; background: linear-gradient(135deg, #28a745 0%, #20c997 100%); border: none;" (click)="confirmAudio()" [disabled]="isUploadingVoice">
                <i class="fas fa-paper-plane fs-3 text-white" *ngIf="!isUploadingVoice"></i>
                <div class="spinner-border text-white" style="width: 1.5rem; height: 1.5rem;" role="status" *ngIf="isUploadingVoice"></div>
              </button>
              <button type="button" class="btn btn-outline-danger rounded-circle shadow-sm d-flex justify-content-center align-items-center" style="width: 60px; height: 60px;" (click)="deleteRecording()" [disabled]="isUploadingVoice">
                <i class="fas fa-trash-alt fs-3"></i>
              </button>
            </div>

            <!-- Recording Confirmed / Ready -->
            <div class="d-flex justify-content-center gap-4" *ngIf="recordedAudioBlob && !isRecording && isAudioConfirmed">
              <button type="button" class="btn btn-outline-success rounded-circle shadow-sm d-flex justify-content-center align-items-center" style="width: 60px; height: 60px;" (click)="playRecordedAudio()">
                <i class="fas fs-3" [ngClass]="isPlayingRecording ? 'fa-pause' : 'fa-play'"></i>
              </button>
              <button type="button" class="btn btn-outline-danger rounded-circle shadow-sm d-flex justify-content-center align-items-center" style="width: 60px; height: 60px;" (click)="deleteRecording()">
                <i class="fas fa-trash-alt fs-3"></i>
              </button>
              <div class="d-flex flex-column justify-content-center align-items-start ms-2">
                <span class="fw-bold text-success"><i class="fas fa-check-circle me-1"></i>Audio Ready</span>
                <small class="text-muted" *ngIf="recordedAudioName">{{ recordedAudioName }}</small>
              </div>
            </div>
          </div>
        </div>

        <div class="actions-container mt-4 mb-5 pb-5">
          <button type="button" class="btn btn-primary btn-lg w-100 rounded-pill shadow" (click)="onSubmit()" style="background: linear-gradient(135deg, #007bff 0%, #0056b3 100%); border: none; padding: 15px;">
            <span *ngIf="!isSubmitting"><i class="fas fa-paper-plane me-2"></i> Submit</span>
            <div class="spinner-border text-white spinner-border-sm" role="status" *ngIf="isSubmitting"></div>
            <span *ngIf="isSubmitting" class="ms-2">Saving...</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Image Preview Lightbox -->
<div class="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" 
     style="background-color: rgba(0,0,0,0.85); z-index: 9999;" 
     *ngIf="previewImageUrl" 
     (click)="closeImagePreview()">
  <button type="button" class="btn-close btn-close-white position-absolute top-0 end-0 m-4" aria-label="Close" (click)="closeImagePreview()"></button>
  <img [src]="previewImageUrl" class="img-fluid rounded shadow-lg" style="max-height: 90vh; max-width: 90vw; object-fit: contain;" (click)="$event.stopPropagation()">
</div>
